import { render } from "./TemplateView.vue?vue&type=template&id=cb22b0e0&ts=true"
import script from "./TemplateView.vue?vue&type=script&lang=ts"
export * from "./TemplateView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__